import FFieldMDP from '@/components/form/field/FFieldMDP';
import { FFormChildMDP } from '@/components/form/FFormMDP';

export default class FOTPMDP implements FFieldMDP {
  componentName = 'FOTP';
  dataSelectorKey: string;
  label: string;
  rules: string;
  mandatory: boolean;
  parentMDP: FFormChildMDP;
  boundaryClass: string;
  disabled: boolean;

  constructor({
    parentMDP,
    dataSelectorKey,
    label,
    rules = '',
    mandatory = false,
    boundaryClass = 'col-12',
    disabled = false,
  }: {
    parentMDP: FFormChildMDP;
    dataSelectorKey: string;
    label: string;
    type?: string;
    rules?: string;
    mandatory?: boolean;
    boundaryClass?: string;
    disabled?: boolean;
  }) {
    this.parentMDP = parentMDP;
    this.dataSelectorKey = dataSelectorKey;
    this.label = label;
    this.rules = rules;
    this.mandatory = mandatory;
    this.boundaryClass = boundaryClass;
    this.disabled = disabled;
  }

  getRules() {
    const required = this.mandatory ? 'required' : '';
    return `${required}|${this.rules}`;
  }

  getBoundaryClass() {
    return `${this.boundaryClass} py-0 px-2`;
  }

  getMetaData(): object {
    return {
      componentName: this.componentName,
      dataSelectorKey: this.dataSelectorKey,
      rules: this.getRules(),
      boundaryClass: this.getBoundaryClass(),
      props: {
        id: this.dataSelectorKey,
        label: this.label,
        outlined: this.parentMDP.outlined,
        dense: this.parentMDP.dense,
        disabled: this.disabled,
      },
    };
  }
}
